import { autoMount } from '../../../utils/autoMount';
import { Contact } from '../../../components/pages/contact';

autoMount({ Contact });
